import React from 'react'

import { bool, string } from 'prop-types'

function InputField({
  id,
  name,
  label,
  placeholder,
  type = 'text',
  autoComplete = 'off',
  required = false,
  isDark = false,
  className = '',
}) {
  return (
    <div className={`discover-field ${className}`}>
      <label htmlFor={id} className={`discover-field__label${isDark ? ' discover-field__label--dark' : ''}`}>
        {label}
      </label>
      <input
        id={id}
        name={name}
        type={type}
        className="discover-field__control"
        placeholder={placeholder}
        autoComplete={autoComplete}
        maxLength={255}
        required={required}
      />
    </div>
  )
}

InputField.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  label: string.isRequired,
  placeholder: string.isRequired,
  type: string,
  autoComplete: string,
  required: bool,
  isDark: bool,
  className: string,
}

export default InputField
